import { Assessment } from "./assessment";
import { Classroom } from "./classroom"
import { Collection } from "./collection";

export enum CollaboratorStatus {
    PENDING = 0,
    ACTIVE = 1
}

export interface ClassroomCollaborator {
    id: number;
    name: string;
    image: string;
    status: CollaboratorStatus;
    roles: {};
    lectures: any[];    
    assessments: Assessment[];
    collections: Collection[];
}

export interface Collaborator {
    id: number;
    name: string;
    email: string;
    status: CollaboratorStatus;
    access_code: string;
    last_updated: string;
    roles: {
        lectures: {
            self: boolean,
            create: boolean,
            delete: boolean
        },
        assessments: {
            self: boolean,
            create: boolean,
            edit: boolean,
            delete: boolean
        },
        library: {
            self: boolean,
            create: boolean,
            edit: boolean,
            delete: boolean
        }
    };
    classroom_id: number;
    classrooms: ClassroomCollaborator[];
}

export const CreateNewCollaborator = (): Collaborator => ({
    id: 0,
    name: '',
    email: '',
    status: CollaboratorStatus.PENDING,
    access_code: '',
    last_updated: '',
    roles: {
        lectures: {
            self: false,
            create: false,
            delete: false
        },
        assessments: {
            self: false,
            create: false,
            edit: false,
            delete: false
        },
        library: {
            self: false,
            create: false,
            edit: false,
            delete: false
        }
    },
    classroom_id: 0,
    classrooms: []
});

export function createCollaboratorPayload(collaborator: Collaborator) {
    return {
        name: collaborator.name,
        email: collaborator.email,
        roles: collaborator.roles,
        classroom_id: collaborator.classroom_id
    };
}

export function updateCollaboratorPayload(collaborator: Collaborator, classroom_id: number) {
    return {
        id: collaborator.id,
        classroom_id: classroom_id,
        roles: collaborator.roles,
    };
}